export default __webpack_public_path__ + "static/media/ecocide_standalone.58ee3037.webp";